import { useState, useRef, useEffect, useCallback } from "react";

// There's no infinite-scroll/pagination pattern elsewhere in this codebase,
// and the lists this feeds (GET /matters, a folder's contents) already come
// back in full from the server — so "infinite scroll" here just means
// revealing more of an already-fetched array as the user scrolls, not
// fetching more pages.
const useProgressiveReveal = (items, pageSize = 40) => {
	const [visibleCount, setVisibleCount] = useState(pageSize);
	const containerRef = useRef(null);

	useEffect(() => {
		setVisibleCount(pageSize);
	}, [items, pageSize]);

	const onScroll = useCallback(() => {
		const el = containerRef.current;
		if (!el) return;
		const nearBottom =
			el.scrollTop + el.clientHeight >= el.scrollHeight - 120;
		if (nearBottom) {
			setVisibleCount((c) => Math.min(c + pageSize, items.length));
		}
	}, [items.length, pageSize]);

	return {
		visibleItems: items.slice(0, visibleCount),
		hasMore: visibleCount < items.length,
		containerRef,
		onScroll,
	};
};

export default useProgressiveReveal;
